import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import TrackingPage from "../pages/tracking/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/seguimiento",
    element: <TrackingPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
